import gql from 'graphql-tag';

export const CREATE_ACADEMIC_ASSESSMENTS = gql`
  mutation ($input: CreateAcademicQualificationAssessmentInput!) {
    createAcademicQualificationAssessment(input: $input) {
      title
    }
  }
`;

export const GET_ACADEMIC_ASSESSMENTS = gql`
  query ($filter: AssessmentFilter!) {
    academicQualificationAssessment(filter: $filter) {
      title
      convertedGPA
      academicQualificationReferenceId
      selectWorldUniversityRanking
      worldUniversityRanking {
        score
        universityLevel
        ranking
        range
        rankNumber
        notExactNumber
      }
      selectNationalRanking
      nationalRanking {
        score
        universityLevel
        ranking
        proof {
          id
          link
          name
        }
      }
      selectWorldSubjectRanking
      worldSubjectRanking {
        score
        universityLevel
        ranking
        range
        subjectArea
      }
      selectDisciplineSpecificList
      disciplineSpecificList {
        score
        universityLevel
        discipline
        ranking
      }
      notApplicable
    }
  }
`;
